import { ROUTES_PATH } from "shared/constants/routesPath";
import { ItemProps } from "./Item/types";
import Invite from "./icons/Invite";
import Scan from "./icons/Scan";
import Settings from "./icons/Settings";
import { redirectToScanApp } from "shared/lib/redirectToScanApp";

export const itemsList: ItemProps[] = [
  {
    icon: <Scan />,
    label: "Сканировать чек",
    callback: (phone: string) => redirectToScanApp(phone),
  },

  {
    icon: <Settings />,
    label: "Личный кабинет",
    href: ROUTES_PATH.ACCOUNT,
  },

  {
    icon: <Invite />,
    label: "Пригласить друга",
    href: ROUTES_PATH.INVITE,
  },
];
